import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class ClosuresOfCashReceiptsExcelWithInvoice {
    exportExcel(data, fecha_inicial, fecha_final) {
        let option = {};  // La opción representa el archivo de Excel
        let closuresOfCashReceipts = this.closuresOfCashReceipts(data, fecha_inicial, fecha_final);
        option.fileName = `Fact-${moment(fecha_inicial).format('DD-MM-YYYY')}-${moment(fecha_final).format('DD-MM-YYYY')}`;  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: closuresOfCashReceipts.data,  // Fuente de datos en archivo Excel
                sheetName: `Fact-${moment(fecha_inicial).format('DD-MM-YYYY')}-${moment(fecha_final).format('DD-MM-YYYY')}`,  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel

    }

    closuresOfCashReceipts(dataReport, fecha_inicial, fecha_final) {
        let dataTable = [];
        let titulosCierreCaja = this.generarTituloConVacios();//Titulos del Recibo de Caja
        let tituloFechaInicial = this.generarTituloFechaInicial(fecha_inicial);
        let tituloFechaFinal = this.generarTituloFechaFinal(fecha_final);

        dataTable.push(titulosCierreCaja);
        dataTable.push(tituloFechaInicial);
        dataTable.push(tituloFechaFinal);
        let Casillas = this.generarCasillas();
        dataTable.push(Casillas);

        for (let i = 0; i < dataReport.length; i++) {
            let casillaRecibo = this.generarCasillasRecibo(dataReport[i]);
            dataTable.push(casillaRecibo);
        }
        let CasillasVacias = this.generarCasillasVacias();
        dataTable.push(CasillasVacias);



        let sheet =
        {
            data: dataTable
        }
        return sheet;
    }

    generarCasillasVacias() {
        let casillas = {
            '1': "",
            '2': "",
            '3': "",
            '4': "",
            '5': "",
            '6': "",
            '7': "",
            '8': "",
            '9': "",
            '10': ""
        }
        return casillas;
    }

    generarTituloConVacios() {
        let Titulos = {
            '1': 'Tipo de Reporte',
            '2': "Cierre de Facturación",
        }
        return Titulos;
    }

    generarTituloFechaInicial(fecha_inicial) {
        let Titulos = {
            '1': 'Fecha Inicial',
            '2': moment(fecha_inicial).format('MMMM Do YYYY'),
        }
        return Titulos;
    }

    generarTituloFechaFinal(fecha_final) {
        let Titulos = {
            '1': 'Fecha Final',
            '2': moment(fecha_final).format('MMMM Do YYYY'),
        }
        return Titulos;
    }

    generarCasillas() {
        let casillas = {
            '1': "Cliente",
            '2': "Plan",
            '3': "Fecha",
            '4': "Factura No.", 
            '5': "Nota Crédito No.",
            '6': "Identificación",
            '7': "Nombre Paciente",
            '8': "Subtotal",
            '9': "Copago",
            '10': "Total"
        }
        return casillas;
    }

    generarCasillasRecibo(dataBilling) {

        let casillas = {
            '1': dataBilling.nombre_tercero,
            '2': dataBilling.nombre_plan,
            '3': moment(dataBilling.fecha_emision).format('DD-MM-YYYY'),
            '4': dataBilling.num_fac_ter,
            '5': dataBilling.folio_nota_credito ?? "-" ,
            '6': dataBilling.varios_pacientes ? 'Nit.' + dataBilling.nit_tercero : dataBilling.num_documento,
            '7': dataBilling.varios_pacientes ? 'PACIENTES VARIOS' : dataBilling.nombre_paciente_facturado,
            '8': parseInt(dataBilling.copago) + parseInt(dataBilling.valor_tercero),
            '9': parseInt(dataBilling.copago),
            '10': parseInt(dataBilling.valor_tercero)
        }
        return casillas;
    }

    generarCasillasSubtotal(subtotal) {
        let casillas = {
            '1': "Subtotal",
            '2': "$ " + subtotal
        }
        return casillas;
    }

    generarCasillasCopagoTarjetas(pago_tarjeta) {
        let casillas = {
            '1': "Pagos Tarjeta",
            '2': "$ " + pago_tarjeta
        }
        return casillas;
    }

    generarCasillasCopagoCheques(pago_cheque) {
        let casillas = {
            '1': "Pagos Cheques",
            '2': "$" + pago_cheque
        }
        return casillas;
    }

    generarCasillasCopagoEfectivo(pago_efectivo) {
        let casillas = {
            '1': "Pagos Efectivo",
            '2': "$" + pago_efectivo
        }
        return casillas;
    }

    generarCasillasCopagoTotal(pago_total) {
        let casillas = {
            '1': "Pago Total",
            '2': "$" + pago_total
        }
        return casillas;
    }

    generarCasillasTotalRecibos(total) {
        let casillas = {
            '1': "Pago Total",
            '2': "$" + total
        }
        return casillas;
    }

}

export default new ClosuresOfCashReceiptsExcelWithInvoice();